import { ConfigConstants } from './config';
import { fetchGet, fetchPost, fetchPut, fetchDelete, fetchPatch, externalGet, externalPost } from './fetchUtils';
import { logout, refreshToken } from './authUtils';
import { reduxStore } from '../index';
import history from './history';
import { BILLSBY_ADMIN_AUTH_DATA_CONTROL } from './constants';
import { IParsedToken, IToken } from '../models/Token';
import { storeGet } from './storeUtils';



function getHeaders() {
  const headers = new Headers();

  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');

  if (storeGet(BILLSBY_ADMIN_AUTH_DATA_CONTROL)) {
    const token = <IToken>storeGet(BILLSBY_ADMIN_AUTH_DATA_CONTROL);
    headers.append('Authorization', 'Bearer ' + token.access_token);
  }

  return headers;
}

export function retryConnection(tries: number) {
  return new Promise((fulfill, reject) => {
    // Refresh token
    refreshToken(BILLSBY_ADMIN_AUTH_DATA_CONTROL, ConfigConstants.companyId).then(() => {
      // Token refreshed successfully
      fulfill();
    }).catch(() => {
      // If refresh token fails, try again 3 times
      tries++;
      if (tries < 3) {
        retryConnection(tries);
      } else {
        logout();
        history.push('/');
      }
    });
  });
}

function getFileUploadHeaders() {
  const headers = new Headers();

  /*if (authData.isAuth) {
    const storeData = storeGet(BILLSBY_AUTH_DATA_CONTROL);
    headers.append('Authorization', 'Bearer ' + storeData.token);
  }*/

  return headers;
}

function getExternalHeaders() {
  const createHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  };

  const headers = new Headers(createHeaders);

  return headers;
}

export function apiGetExternal(req: string) {
  return externalGet(req, getExternalHeaders());
}

export function apiPostExternal(req: string, data: object) {
  return externalPost(req, getExternalHeaders(), JSON.stringify(data));
}

export function apiGet(request: string) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchGet(url, getHeaders())
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiGet(request).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiPost(request: string, data: object, isMock?: boolean) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchPost(url, getHeaders(), JSON.stringify(data))
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiPost(request, data).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiPatch(request: string, data: object) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchPatch(url, getHeaders(), JSON.stringify(data))
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiPatch(request, data).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiPostFiles(request: string, data: object) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchPost(url, getFileUploadHeaders(), data)
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiPostFiles(request, data).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiPutFiles(request: string, data: object) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchPut(url, getFileUploadHeaders(), data)
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiPutFiles(request, data).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiPut(request: string, data: object) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchPut(url, getHeaders(), JSON.stringify(data))
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiPut(request, data).then((response) => {
              fulfill(response);
            });
          });
        } else {
          if (error.status === 403) {
            history.push('/forbidden');
          } else {
            reject(error);
          }
        }
      });
  });
}

export function apiDelete(request: string) {
  return new Promise((fulfill, reject) => {
    const url = ConfigConstants.baseUrl + request;

    fetchDelete(url, getHeaders())
      .then((response) => {
        fulfill(response);
      }).catch((error) => {
        if (error.status === 401) {
          retryConnection(0).then(() => {
            apiDelete(request).then((response) => {
              fulfill(response);
            });
          });
        } else {
          reject(error);
        }
      });
  });
}

export function parseJSON(response: any) {
  return response.json();
}